import api from "@/api";
import { AxiosResponse } from "axios";
import GenderData from "@/types/GenderData";

async function getAvaibleGenders(): Promise<AxiosResponse<GenderData[]>> {
  return await api.get<GenderData[]>("/api/genders");
}

export default getAvaibleGenders;
